<template>
  <v-card class="card pa-6 mx-auto" elevation="1">
    <div class="px-2 d-flex" style="justify-content: center; text-align: center">
      <h2 class="justify-center">
        <span style="margin-bottom: 10px">
          Pedido enviado? <br />
        </span>

        <span v-if="this.order.melhorEnvioId == null">
           Insira o código de rastreio
        </span>
      </h2>
    </div>
    <v-form v-if="this.order.melhorEnvioId == null" ref="firstForm">
      <v-col cols="12" sm="12" md="12" lg="12">
      <v-text-field
          dense
          outlined
          placeholder="Insira o código de rastreio"
          v-model="trackingCode"
          required
          :rules="[rules.required]"

      />

      <v-text-field
          dense
          outlined
          placeholder="Nome da transportadora"
          :rules="[rules.required]"
          v-model="companyName"
          required
      />

      <v-text-field
          dense
          outlined
          placeholder="Link para rastreio"
          :rules="[rules.required]"
          v-model="trackingLink"
          required
      />
    </v-col>
    </v-form>
    <div>
      <v-row class="d-flex ma-0 pa-0">
        <v-col cols="12" class="d-flex justify-center">
          <v-btn outlined class="cancelBtn mr-2" @click="close" :loading="loading">
            <span class="cancel">Cancelar</span>
          </v-btn>

          <v-btn class="okBtn mr-2" @click="action()" :loading="loading">
            <span class="yep">Confirmar</span>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<style scoped>
.input-modal {
  background: #f5f5f5 !important;
  border: 2px solid #b9b9b9 !important;
  border-radius: 16px !important;
}
.yep {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.15px;

  color: #ffffff;
}
.cancel {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;

  color: #2d3038;
}
.card {
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 11px;
}

.cancelBtn {
  width: 200px !important;
  height: 50px !important;

  border: 2px solid #2d3038 !important;
  box-sizing: border-box;
  border-radius: 6px;
}

.okBtn {
  width: 200px !important;
  height: 50px !important;

  background: #2d3038 !important;
  border-radius: 6px;
}

@media (max-width: 600px) {
  .select-type {
    width: 50% !important;
  }
}
</style>

<script>
import ApiService from "../../../services/ApiService";

export default {
  name: "EnviadoStatusModal",

  props: {
    order: Object,
  },

  data: () => ({
    loading: false,
    apiService: new ApiService(),
    trackingCode: null,
    companyName: null,
    trackingLink: null,
    rules: {
      required: ""
    }
  }),

  async created() {
  },

  methods: {
    close() {
      this.$emit("close");
    },

    action() {
      if (this.order.melhorEnvioId == null){
        this.rules.required =  (value) => !!value || "Campo requerido.";
        if (!this.$refs.firstForm.validate()){
          return;
        }
      }

      this.$emit("action", {trackingCode: this.trackingCode, companyName: this.companyName, trackingLink: this.trackingLink});
    },
  },
};
</script>
